import { useState } from "react";
import { Snackbar, Typography } from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
import { IMessage } from "../../redux/reducers/messagesReducer";

export type Severity = "success" | "info" | "warning" | "error";

interface IToast {
  message: IMessage;
  duration?: number;
  onClose?: (message: IMessage) => void;
}

const Toast = ({ message, onClose, duration = 3000 }: IToast) => {
  const { text, severity } = message;
  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
    if (onClose) {
      onClose(message);
    }
  };

  return (
    <Snackbar open={open} autoHideDuration={duration} onClose={handleClose}>
      <div>
        <MuiAlert elevation={6} variant="filled" severity={severity}>
          <Typography variant="body2" style={{ color: "white" }}>
            {text}
          </Typography>
        </MuiAlert>
      </div>
    </Snackbar>
  );
};

export default Toast;
